import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { FiUsers } from "react-icons/fi";
import { AiOutlineAntDesign } from "react-icons/ai";
import { AiOutlineMenu } from "react-icons/ai";
import React, { useEffect, useState } from "react";
import Addtestimonials from "../components/Addtestimonials";
import AddcaseStudy from "../components/AddcaseStudy";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;
const Admin = (props) => {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [active, setActive] = useState(0);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const handleClick = (params) => {
    params === "Testimonials" ? setActive(0) : setActive(1);
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("admin"))) {
      navigate("/admin/login");
    }
  }, []);

  const drawer = (
    <div>
      <h2 className="font-semibold text-3xl text-center my-4">Dashboard</h2>
      <List>
        {["Testimonials", "UI/UX Study"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton
              sx={{
                bgcolor: `${index === active ? "#FE4904" : ""}`,
                color: `${index === active ? "white" : ""}`,
              }}
              onClick={() => handleClick(text)}
            >
              <ListItemIcon>
                {index % 2 === 0 ? (
                  <FiUsers
                    className={`${
                      index === active ? "text-white" : "text-black"
                    }`}
                  />
                ) : (
                  <AiOutlineAntDesign
                    className={`${
                      index === active ? "text-white" : "text-black"
                    }`}
                  />
                )}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );
  return (
    <Box sx={{ display: "flex" }}>
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar className="bg-gradient-to-r from-[#FE4904] to-[#F7164C]">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <AiOutlineMenu />
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            Admin Panel
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      {active === 0 && <Addtestimonials />}
      {active === 1 && <AddcaseStudy />}
    </Box>
  );
};
export default Admin;
